import {Form, Modal} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import {ReactElement} from 'react';

import {Locale} from '../../../../../provider/locale/locale';
import {useLocale} from '../../../../../provider/locale/locale-hook';
import {useFormRules} from '../../../../../service/form/form-rules-hook';
import {NoteFormType} from '../../../../../service/reviews/reviews-notes';

const bulkNoteFormId = 'bulk-review-note-form';

type PropsType = {
    isLoading: boolean;
    onCancel: () => void;
    onSubmit: (formValues: NoteFormType) => void | Promise<void>;
};

export function BulkReviewNoteModal(props: PropsType): ReactElement {
    const {isLoading, onCancel, onSubmit} = props;
    const {getLocalizedString} = useLocale();
    const [form] = Form.useForm<NoteFormType>();
    const {requiredFieldTrimmedTextRule} = useFormRules();

    async function onSubmitForm() {
        await onSubmit(form.getFieldsValue());
        form.resetFields();
    }

    return (
        <Form<NoteFormType> form={form} id={bulkNoteFormId}>
            <Modal
                okButtonProps={{loading: isLoading}}
                okText={<Locale stringKey="BUTTON__SAVE" />}
                onCancel={onCancel}
                onOk={onSubmitForm}
                open
                title={<Locale stringKey="REVIEWS__NOTE_MODAL__TITLE" />}
            >
                <Form.Item name="text" rules={[requiredFieldTrimmedTextRule()]}>
                    <TextArea autoFocus placeholder={getLocalizedString('REVIEWS__ENTER_YOUR_NOTE_TEXT')} rows={5} />
                </Form.Item>
            </Modal>
        </Form>
    );
}
